<template>
  <div class="reservation-history-display">
    <template v-if="tekbox">
      <template v-for="(item, index) in history">
        <div class="res-history">
          <div :class="
          [
          'icon-history',
          {
            'bg-success': item.messageType.match('newReservation|tripData'),
            'bg-amber': item.messageType.match('modifyReservation'),
            'bg-info': item.messageType.match('ignition'),
            'bg-warning': item.messageType.match('voltage'),
            'bg-danger': item.messageType.match('cancelReservation'),
            'bg-default': item.messageType.match('startReservation'),
            'bg-purple': item.messageType.match('cardSwiped')
          }
          ]">
          <span v-if="item.messageType.includes('newReservation')" class="fa fa-calendar-plus"></span>
          <span v-if="item.messageType.includes('modifyReservation')" class="fa fa-pen-square"></span>
          <span v-if="item.messageType.includes('startReservation')" class="fa fa-sign-in-alt"></span>
          <span v-if="item.messageType.includes('cardSwiped')" class="fa fa-map-marker-alt"></span>
          <span v-if="item.messageType.includes('ignition')" class="fa fa-power-off"></span>
          <span v-if="item.messageType.includes('tripData')" class="fa fa-check"></span>
          <span v-if="item.messageType.includes('voltage')" class="fa fa-bolt"></span>
          <span v-if="item.messageType.includes('cancelReservation')" class="fa fa-ban"></span>
          <!-- <div class="vert-line"></div> -->
        </div>
        <div class="card card-secondary">
          <div class="card-header">
            {{ item.heading }}
            <template v-if="item['Car.name']">for #{{ item['Car.convadisId'] }} - {{ item['Car.name'] }}</template>
            <p class="small text-dark m-0 mt-1">
              <span class="fa fa-clock"></span> {{ item.createdAt | short_date_time_format(timezone) }}
            </p>
          </div>
          <div v-if="expand[index]" class="card-body" transition="expand">
            <div class="extra-info">
              <template v-if="item.rawMessage.TekboxResponse && item.rawMessage.TekboxResponse.GPS && item.rawMessage.TekboxResponse.GPS.Latitude && item.rawMessage.TekboxResponse.GPS.Longitude">
                <p><img class="google-map small" :src="'https://maps.googleapis.com/maps/api/staticmap?center='+ item.rawMessage.TekboxResponse.GPS.Latitude +','+ item.rawMessage.TekboxResponse.GPS.Longitude +'&zoom=15&size=200x200&maptype=roadmap&markers=color:blue%7Clabel:%7C'+ item.rawMessage.TekboxResponse.GPS.Latitude +','+ item.rawMessage.TekboxResponse.GPS.Longitude +'&key=AIzaSyChsNbsujgDDgecCVkJNUkG2WFntMXPZ4c'" alt="Car Location"></p>
                <p><a :href="'https://www.google.com/maps?q='+ item.rawMessage.TekboxResponse.GPS.Latitude +','+ item.rawMessage.TekboxResponse.GPS.Longitude" target="_blank">[ <span class="fa fa-search"></span> View on google maps ]</a></p>
              </template>
              <template v-if="item.messageType.includes('newReservation')">
                <p><strong>Scheduled for:</strong> {{ item.rawMessage.TekboxRequest.StartDateTime | short_date_time_format(timezone) }}</p>
                <p><strong>Expires at:</strong> {{ item.rawMessage.TekboxRequest.EndDateTime | short_date_time_format(timezone) }}</p>
              </template>
              <template v-if="item.messageType.includes('tripData')">
                <div class="google-map"><div id="reservation_map" style="height:450px;"></div></div>
                <p :class="{ 'red': late }"><strong>Reservation Completed:</strong> {{ item.rawMessage.TekboxResponse.CompletedEndDateTime | short_date_time_format(timezone) }}</p>
                <p><strong>KM Driven:</strong> {{ item.rawMessage.TekboxResponse.CompletedKms }}km</p>
                <strong>KM Driven Estimate (Geodesic):</strong> {{ distance }}km
              </template>
              <template v-if="item.messageType.includes('modifyReservation')">
                <p><strong>New Start Date:</strong> {{ item.rawMessage.TekboxRequest.StartDateTime | short_date_time_format(timezone) }}</p>
                <p><strong>New End Date:</strong> {{ item.rawMessage.TekboxRequest.EndDateTime | short_date_time_format(timezone) }}</p>
              </template>
              <template v-if="item.messageType.includes('voltage')">
                <p><strong>Voltage Reported:</strong> {{ item.rawMessage.TekboxResponse.Voltage }}</p>
              </template>
            </div>
          </div>
          <div class="expand-icon text-center" @click="toggleInfo(index, item.messageType)">
            <span :class="{ 'fa fa-chevron-up': expand[index], 'fa fa-chevron-down': !expand[index]}"></span>
          </div>
        </div>
      </div>
      <br/>
      </template>
    </template>
    <template v-if="!tekbox">
      <template v-for="(item, index) in history">
        <div class="res-history">
          <div :class="
          [
            'icon-history',
            {
              'green-icon': item.message.match('Creating|Trip data'),
              'amber-icon': item.message.match('Changing'),
              'blue-icon': item.message.match('Ignition'),
              'yellow-icon': item.message.match('Alarm'),
              'red-icon': item.message.match('Cancelling|Failure'),
              'purple-icon': item.message.match('Early|Modifying|Modification'),
              'grey-icon': item.message.match('Identification|Tech'),
              'pink-icon': item.message.match('Changed')
            }
          ]">
            <span v-if="item.message.includes('Creating')" class="fa fa-calendar-plus"></span>
            <span v-if="item.message.includes('Tech')" class="fa fa-cloud-upload-alt"></span>
            <span v-if="item.message.includes('Modifying')" class="fa fa-pen-square"></span>
            <span v-if="item.message.includes('Modification')" class="fa fa-pen-square"></span>
            <span v-if="item.message.includes('Identification')" class="fa fa-sign-in-alt"></span>
            <span v-if="item.message.includes('Alarm')" class="fa fa-map-marker-alt"></span>
            <span v-if="item.message.includes('Ignition')" class="fa fa-power-off"></span>
            <span v-if="item.message.includes('Trip data')" class="fa fa-check"></span>
            <span v-if="item.message.includes('Cancelling')" class="fa fa-ban"></span>
            <span v-if="item.message.includes('Changing')" class="fa fa-car"></span>
            <span v-if="item.message.includes('Early')" class="fa fa-fast-forward"></span>
            <span v-if="item.message.includes('Changed')" class="fa fa-map-signs"></span>
            <span v-if="item.message.includes('Failure')" class="fa fa-exclamation-triangle"></span>
            <!-- <div class="vert-line"></div> -->
          </div>
          <div class="message-header">
            <h2><span class="fa fa-clock"></span> {{ item.timeStampCComD | short_date_time_format(timezone) }}</h2>
            <h4>{{ item.heading }}</h4>
            <transition name="expand">
              <div v-if="expand[index]" class="extra-info">
                <div class="extra-info-text">
                  <template v-if="item.latitude && item.longitude">
                    <p><img class="google-map small" v-bind:src="'https://maps.googleapis.com/maps/api/staticmap?center='+ item.latitude +','+ item.longitude +'&zoom=15&size=200x200&maptype=roadmap&markers=color:blue%7Clabel:%7C'+ item.latitude +','+ item.longitude +'&key=AIzaSyChsNbsujgDDgecCVkJNUkG2WFntMXPZ4c'" alt="Car Location"></p>
                    <p><a :href="'https://www.google.com/maps?q='+ item.latitude +','+ item.longitude" target="_blank">[ <span class="fa fa-search"></span> View on google maps ]</a></p>
                  </template>
                  <template v-if="item.rawMessage['ns2:Body'] && !item.rawMessage.Tripdata">
                    <h3><strong>Scheduled for:</strong> {{ item.rawMessage['ns2:Body'].SBP12SendReservationToVehicle.StartDateTime | short_date_time_format(timezone) }}</h3>
                    <h3><strong>Expires at:</strong> {{ item.rawMessage['ns2:Body'].SBP12SendReservationToVehicle.EndDateTime | short_date_time_format(timezone) }}</h3>
                  </template>
                  <template v-if="item.rawMessage.Tripdata">
                    <div class="google-map"><div id="reservation_map" style="height:450px;"></div></div>
                    <h3 :class="{ 'red': late }"><strong>Reservation Completed:</strong> {{ item.rawMessage.Tripdata.LogoutTimeAfterLastRide | short_date_time_format(timezone) }}</h3>
                    <h3><strong>KM Driven:</strong> {{ item.rawMessage.Tripdata.DrivenKm }}km</h3>
                    <strong>KM Driven Estimate (Geodesic):</strong> {{ distance }}km
                  </template>
                  <template v-if="item.message.includes('Modification')">
                    <h3><strong>End Date Wanted:</strong> {{ item.rawMessage.Identification.EndDateTime | short_date_time_format(timezone) }}</h3>
                  </template>
                </div>
              </div>
            </transition>
            <div v-if="item.message.indexOf('Cancelling') === -1" class="expand-icon" @click="toggleInfo(index, item.message)">
              <span :class="{ 'fa fa-chevron-up': expand[index], 'fa fa-chevron-down': !expand[index]}"></span>
            </div>
          </div>
        </div>
        <br/>
      </template>
    </template>
  </div>
</template>

<script>
export default {
  name: 'ReservationHistoryDisplay',
  props: {
    history: {
      type: Array
    },
    timezone: {
      type: String,
      default () {
        return 'Australia/Melbourne'
      }
    },
    completedEndDate: {
      type: String
    },
    endDate: {
      type: String
    }
  },
  data () {
    return {
      expand: [],
      googleMap: false,
      markers: [],
      distance: 0
    }
  },
  mounted () {
    this.expand = []
    this.googleMap = false
    this.markers = []
    this.distance = 0
  },
  computed: {
    tekbox () {
      return Boolean(this.history && this.history.length && this.history[0].type)
    },
    late () {
      if (this.completedEndDate) {
        let sEnd = moment(this.endDate)
        let aEnd = moment(this.completedEndDate)
        let mDiff = aEnd.diff(sEnd, 'minutes')
        if (mDiff > 5) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    }
  },
  methods: {
    toggleInfo (index, message) {
      this.$set(this.expand, index, !this.expand[index])
      if (this.googleMap) {
        this.googleMap = false
      }
      this.$nextTick(function () {
        if (message.match('Trip data|tripData')) {
          this.makeMap()
        }
      })
    },
    makeMap () {
      this.googleMap = new google.maps.Map(document.getElementById('reservation_map'), {
        zoom: 15
      })
      let coords = []
      let label = 1
      this.history.forEach(hist => {
        let latitude = false
        let longitude = false
        if (this.tekbox && hist.rawMessage.TekboxResponse && hist.rawMessage.TekboxResponse.GPS) {
          latitude = parseFloat(hist.rawMessage.TekboxResponse.GPS.Latitude)
          longitude = parseFloat(hist.rawMessage.TekboxResponse.GPS.Longitude)
        } else {
          latitude = hist.latitude
          longitude = hist.longitude
        }
        if (parseInt(latitude) && parseInt(longitude)) {
          coords.push({
            lat: latitude,
            lng: longitude
          })
          let latlng = new google.maps.LatLng(latitude, longitude)
          this.markers.push(new google.maps.Marker({
            map: this.googleMap,
            position: latlng,
            optimized: false,
            zIndex: 0,
            label: label.toString()
          }))
          label++
        }
      })
      let polyLine = new google.maps.Polyline({
        path: coords,
        geodesic: true,
        strokeColor: '#1976D2',
        strokeOpacity: 0.6,
        strokeWeight: 4
      })
      polyLine.setMap(this.googleMap)
      let bounds = new google.maps.LatLngBounds()
      for (let i = 0; i < this.markers.length; i++) {
        bounds.extend(this.markers[i].getPosition())
      }
      this.googleMap.fitBounds(bounds)
      this.distance = (google.maps.geometry.spherical.computeLength(polyLine.getPath().getArray()) / 1000).toFixed(2)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/displays/ReservationHistoryDisplay.vue